import { Wrapper } from './styles'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { useMemo } from 'react'
import { DefaultTheme } from 'styled-components'

interface AddItemProps {
    children: React.ReactNode
    onClick: () => void
    theme?: DefaultTheme
    testId?: string
    shouldKeepBorderInDarkMode?: boolean
    isDisabled?: boolean
}

const AddItem = ({
    children,
    onClick,
    theme,
    shouldKeepBorderInDarkMode,
    testId,
    isDisabled,
}: AddItemProps) => {
    const hasDarkMode = theme?.mode === 'dark'
    const textColor = useMemo(() => {
        if (hasDarkMode) return 'grayscale_400'
        if (isDisabled) return 'grayscale_500'
        return 'secondary_500'
    }, [hasDarkMode, isDisabled])

    return (
        <Wrapper
            as="button"
            isFullWidth
            pt={[22, 32]}
            pb={[22, 32]}
            gap={12}
            direction="row"
            justify="center"
            align="center"
            onClick={() => onClick()}
            theme={theme}
            shouldKeepBorderInDarkMode={shouldKeepBorderInDarkMode}
            isDisabled={isDisabled}
            data-testid={testId}
        >
            <Icon variant="add" color={textColor} size={[20, 24]} />

            <Text variant="bodyStrong" color={textColor}>
                {children}
            </Text>
        </Wrapper>
    )
}

export default AddItem
